/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const MediaGroup = {
    Default: 'Default',
    Profile: 'Profile',
    Cover: 'Cover',
    Detail: 'Detail',
    Thumbnail: 'Thumbnail',
    Banner: 'Banner',
    Attachment: 'Attachment',
    Video: 'Video',
    Audio: 'Audio',
    Icon: 'Icon',
    Background: 'Background',
    Logo: 'Logo',
    Certificate: 'Certificate',
    Screenshot: 'Screenshot',
    Other: 'Other'
} as const;
export type MediaGroup = typeof MediaGroup[keyof typeof MediaGroup];


export function instanceOfMediaGroup(value: any): boolean {
    for (const key in MediaGroup) {
        if (Object.prototype.hasOwnProperty.call(MediaGroup, key)) {
            if (MediaGroup[key as keyof typeof MediaGroup] === value) {
                return true;
            }
        }
    }
    return false;
}

export function MediaGroupFromJSON(json: any): MediaGroup {
    return MediaGroupFromJSONTyped(json, false);
}

export function MediaGroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): MediaGroup {
    return json as MediaGroup;
}

export function MediaGroupToJSON(value?: MediaGroup | null): any {
    return value as any;
}

export function MediaGroupToJSONTyped(value: any, ignoreDiscriminator: boolean): MediaGroup {
    return value as MediaGroup;
}

